import {takeLatest, takeEvery} from 'redux-saga/effects';

import * as actionTypes from '../actions/actionTypes';
import * as map from './map';
import fetchUserData from './user';

export default function* watchActions() {
  // Map actions.
  yield takeLatest(actionTypes.SUBMIT_MAP_SEARCH, map.updateFilters);
  yield takeEvery(actionTypes.UPDATE_FACETS, map.updateFacets);
  yield takeLatest(actionTypes.GET_TRANSIT_TYPES, map.getTransitTypes);
  yield takeLatest(actionTypes.GET_POI_CATEGORIES, map.getPoiCategories);
  yield takeEvery(actionTypes.GET_JURISDICTIONS, map.getJurisdictions);
  yield takeLatest(actionTypes.SET_MAP_GEOMETRY, map.updateClusters);
  yield takeLatest(actionTypes.SET_GRID_INITIALIZED, map.refreshClustersAfterGridInit);
  yield takeLatest(actionTypes.UPDATE_LIST_RESULTS, map.updateListResults);
  yield takeLatest(actionTypes.FETCH_FOLLOWED_PROPERTIES, map.fetchFollowedProperties);
  yield takeLatest(actionTypes.FETCH_RECENT_ADDITIONS, map.fetchRecentAdditions);
  yield takeLatest(actionTypes.INIT_CLUSTERS, map.initClusters);

  // User actions.
  yield takeLatest(actionTypes.FETCH_USER_DATA, fetchUserData);
}
